import { render, staticRenderFns } from "./FormatPageObjectDrawer.vue?vue&type=template&id=745c1da1&scoped=true&"
import script from "./FormatPageObjectDrawer.vue?vue&type=script&lang=ts&"
export * from "./FormatPageObjectDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./FormatPageObjectDrawer.vue?vue&type=style&index=0&id=745c1da1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745c1da1",
  null
  
)

export default component.exports